module.exports = __webpack_public_path__ + "static/media/profile.ab8abd3a.png";